import { useEffect, useState } from "react";
import "./AtivarOrigemCarregamentoTrilhosReempregoModal.css";

export default function AtivarOrigemCarregamentoTrilhosReempregoModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao ativar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocrat-bg" onClick={onClose}>
      <div className="ocrat-box" role="dialog" aria-modal="true" aria-label="Ativar origem reemprego" onClick={(e) => e.stopPropagation()}>
        <header className="ocrat-head">
          <h3 className="ocrat-title">Ativar</h3>
          <button className="ocrat-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="ocrat-body">
          Deseja <strong>ativar</strong> "{titulo || "esta origem"}"?
          {err ? <div className="ocrat-err">{err}</div> : null}
        </div>
        <footer className="ocrat-foot">
          <button className="ocrat-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ocrat-btn ocrat-btn-ok" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Ativando..." : "Ativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}


